import { ThrowStmt } from '@angular/compiler';
import { iif } from 'rxjs';
import { COUNTRIES } from './countries';
import { PROVINCE }  from './countries';
import { PROVINCE_CITTA } from './countries';
import { CAP_CITTA } from './countries';
import { CAP_PROVINCE } from './countries';
import { CITTA } from './countries';
import { CITTA_PROVINCE } from './countries';

export class Address{
    private selected_country :string|null;
    private selected_city:string|null;
    private selected_province:string|null;
    private selected_cap:string|null;

    private countries:string[];
    private provinces:string[];
    private cities:string[];
    private postCodes:string[];
    private group:string|null;

    constructor(){
        this.selected_country=null;
        this.selected_city=null;
        this.selected_province=null;
        this.selected_cap=null;
        this.countries=COUNTRIES;
        this.provinces=[];
        this.postCodes=[];
        this.cities=[];
        this.group=null;
    }

    public getProvinceDataAttr(){
        return 'province';
    }

    public getCityDataAttr(){
        return 'city';
    }

    public getPostCodeAttr(){
        return 'postcode';
    }

    public getGroup(event :Event){
        let elm=(event.target as HTMLInputElement);
        if(this.group==elm.getAttribute('data-address'))
                return true;
        return false;
    }

    public isActiveGroup(group :string){
        return (group==this.group)?true:false;
    }

    public getCountries(){
            return this.countries;
    }

    public getProvinces(){
        return this.provinces;
    }

    public getCities(){
        return this.cities;
    }

    public getPostalCodes(){
        /*if(this.postCodes.length==0){
                if((this.selected_country=='IT') && (this.selected_province!=null)){
                        //se la cità è settata ed esiste allora prendo i cap disponibili
                        if(this.selected_city!=null)
                                if((CAP_CITTA as any)[this.selected_city]!=undefined){
                                    this.postCodes=(CAP_CITTA as any)[this.selected_city];
                                    return this.postCodes;
                                }

                        //altrimenti cerco cap nell'intera provincia...
                        if((CAP_PROVINCE as any)[this.selected_province]!=null){
                            this.postCodes=(CAP_PROVINCE as any)[this.selected_province];
                            this.postCodes= [...new Set(this.postCodes)];
                        }
                }
        }*/
        return this.postCodes;
    }




    public setGroup(event: Event){
        let elm=(event.target as HTMLInputElement);
        //abbiamo solo dati per l'italia per il momento..
        if(!this.existCountry(elm.value))
            return;
        try{
            this.group=elm.getAttribute('data-address');
        }catch(e){
            return;
        }
    }

    private existCountry(val: string){
        if((val.length!=2) || (val!="IT")){
                this.resetProps();
                return false;
        }
        this.selected_country=val;
        this.setProvince();
        return this.countries.includes(val.toUpperCase())?true:false;
    }

    private resetProps(){
        //console.log("reset");
        this.selected_country=null;
        this.selected_city=null;
        this.selected_province=null;
        this.selected_cap=null;
        this.countries=COUNTRIES;
        this.provinces=[];
        this.postCodes=[];
        this.cities=[];
        //this.group=null;
    }

    private setProvince(){
            this.provinces=PROVINCE;
    }

    public setCities(event: Event){
        if(!this.getGroup(event)){
            if(!this.forceGroup(event))
                return;
        } 
        this.selected_province=(this.getElmVal(event)!="")?this.getElmVal(event):null;

        if(this.selected_country!=null){
            if((PROVINCE_CITTA as any)[this.getElmVal(event)]!= undefined){
                this.cities=(PROVINCE_CITTA as any)[this.getElmVal(event)];
                return;
            }
        }
    }

    public setActiveCap(event: Event){
        //verifico se esiste il cap per la provincia..
        if(!this.getGroup(event)){
            if(!this.forceGroup(event))
                    return;
        } 
        if(this.selected_province!=null){
            if((CAP_PROVINCE as any)[this.selected_province].includes(this.getElmVal(event)) ){
                        //il cap esiste nella provincia...
                        this.selected_cap=this.getElmVal(event);
                        
                        //rigenero città dal cap;
                        this.cities=[];
                        (Object.keys(CAP_CITTA) as (keyof typeof CAP_CITTA)[]).forEach((key, index) => {
                            if(CAP_CITTA[key].includes(this.selected_cap!)){
                                    this.cities.push(key);
                            }
                        });
                        return;
            }

            if((PROVINCE_CITTA as any)[this.selected_province]!= undefined){
                this.cities=(PROVINCE_CITTA as any)[this.selected_province];
                return;
            }

            this.selected_cap=null;
            return;    
        }
        this.selected_cap=null;
        return;
    }

    public forceGroup(event :Event){
        try{
            let elm=(event.target as HTMLInputElement);
            let pointer=(document.querySelector("[list='countries'][data-address='"+elm.getAttribute('data-address')+"']") as HTMLInputElement);
            if(pointer!=undefined){
                if(pointer.value=="IT"){
                        this.resetProps();
                        this.group=elm.getAttribute('data-address');
                        this.selected_country='IT';
                        let addpart=elm.dataset.addpart;
                            switch(addpart){
                                case 'province' : this.restoreProvinces(); break;
                                case 'city' : this.restoreCities(); break;
                                case 'cap' : this.restoreProvinces(); break;
                            }
                        return true;
                }
            }  
            return false;         
        }catch(e){
            return false;
        }
    }

    private restoreProvinces(){
        //leggo il valore di città e nal caso rigenero la lista 
        let city=(document.querySelector("[data-addpart='city'][data-address='"+this.group+"']") as HTMLInputElement);
        if(city.value!=""){
            this.selected_city=city.value;
            if((CITTA_PROVINCE as any)[city.value]!= undefined)
                this.provinces=(CITTA_PROVINCE as any)[city.value];
            if((CAP_CITTA as any)[city.value]!=undefined){
                this.postCodes=(CAP_CITTA as any)[city.value];
            }

        }else{
            this.selected_province=(document.querySelector("[data-addpart='province'][data-address='"+this.group+"']") as HTMLInputElement).value;
            if(this.selected_province=="")
                    this.selected_province=null;

            if(this.selected_province!=null){
                if((CAP_PROVINCE as any)[this.selected_province]!=null){
                    this.postCodes=(CAP_PROVINCE as any)[this.selected_province];
                    this.postCodes= [...new Set(this.postCodes)];
                }
            }
            else{
                this.postCodes=[];
            }
            this.setProvince();
        }
    }


    private restoreCities(){
        let province=(document.querySelector("[data-addpart='province'][data-address='"+this.group+"']") as HTMLInputElement);
        let cap=(document.querySelector("[data-addpart='cap'][data-address='"+this.group+"']") as HTMLInputElement);
        if(province.value!=""){
                this.selected_province=province.value;
            if((PROVINCE_CITTA as any)[this.selected_province].includes(cap.value)){
                this.selected_cap=cap.value;
                this.cities=[];
                (Object.keys(CAP_CITTA) as (keyof typeof CAP_CITTA)[]).forEach((key, index) => {
                    if(CAP_CITTA[key].includes(this.selected_cap!)){
                            this.cities.push(key);
                    }
                });
            }else{
                if((PROVINCE_CITTA as any)[province.value]!= undefined)
                this.cities=(PROVINCE_CITTA as any)[province.value];
            }
        }else{
            this.selected_province=null;
        }
    }


    public testCities(event: Event){
        if(!this.getGroup(event)){
            if(!this.forceGroup(event))
                    return;
        } 
        if(this.selected_country!="IT") return;
        let curVal=this.getElmVal(event);
        if((this.selected_province!=null) || (this.getElmVal(event).length <3))
             return;
        if(CITTA.includes(curVal)) return;
        this.cities=[];
            CITTA.forEach((value, index) => {
                if(value.indexOf(curVal) !== -1){
                        this.cities.push(value);
                }
            });
    }



    public setPotsalCodes(event: Event){
        if(!this.getGroup(event)){
            if(!this.forceGroup(event))
                    return;
        } 
        if((this.selected_country!='IT'))
                return;

        this.selected_city=(this.getElmVal(event)!="")?this.getElmVal(event):null;        
        //controllo se la città inserita esiste altrimenti ignoro.
        //forzo ricalcolo codice postale...

        if((this.selected_city!=null) && (this.selected_city.length>2)){
                if(this.selected_province!=null){
                    if(!(PROVINCE_CITTA as any)[this.selected_province].includes(this.getElmVal(event)))
                            return;
                }else{
                    if((CITTA_PROVINCE as any)[this.selected_city]!=null)
                        this.provinces=(CITTA_PROVINCE as any)[this.selected_city];
                }
        }                   
        
    }


    



    public getPostalCode(event: Event){   
        if(!this.getGroup(event)){
            if(!this.forceGroup(event))
                    return;
        }

        if(this.selected_city!=null){
            if((CAP_CITTA as any)[this.selected_city]!=undefined)
                this.postCodes=(CAP_CITTA as any)[this.selected_city];
        }else{
                if(this.selected_province!=null){
                    if((CAP_PROVINCE as any)[this.selected_province]!=null){
                        this.postCodes=(CAP_PROVINCE as any)[this.selected_province];
                        this.postCodes= [...new Set(this.postCodes)];
                    }
                }
            }
    }

    private getElmVal(event: Event){
        let elm=(event.target as HTMLInputElement);
        return elm.value;
    }
}